import { __read, __spread } from "tslib";
import React, { useMemo, useCallback } from 'react';
import { Grid } from '@marvelapp/ui';
import { ItemUtils, ItemClass } from '@marvelapp/design-creator';
import { useLayerState, useLayerItemsMap } from './hooks';
import Layer from './Layer';
function LayerListItem(_a) {
    var item = _a.item, onSelect = _a.onSelect, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, isClipped = _a.isClipped;
    var _b = useLayerState(item), isSelected = _b.isSelected, isExpanded = _b.isExpanded, setIsExpanded = _b.setIsExpanded, isHidden = _b.isHidden, filterText = _b.filterText;
    var itemsMap = useLayerItemsMap();
    var layerChildren = useMemo(function () { return item.children && __spread(item.children).reverse(); }, [item.children]);
    var handleCollapse = useCallback(function (e) {
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    }, [isExpanded, setIsExpanded]);
    if (isHidden) {
        return null;
    }
    var isMask = ItemUtils.getClassName(item) === ItemClass.Mask;
    var hasExpandedChildren = !isHidden && layerChildren && isExpanded;
    var shouldRenderChildren = isMask || hasExpandedChildren;
    // Children of Mask type are rendered flat, so we don't display any
    // content and just continue to render the children
    var layerContent = !isMask && (React.createElement(Layer, { filterText: filterText, isClipped: isClipped, isCollapsed: !isExpanded, isSelected: isSelected, item: item, onCollapse: handleCollapse, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onSelect: onSelect }));
    return (React.createElement(React.Fragment, null,
        layerContent,
        shouldRenderChildren && (React.createElement(Grid, { gridRowGap: 1, gridTemplateColumns: "100%", paddingLeft: isMask ? 0 : 22 }, layerChildren.map(function (id, idx) { return (React.createElement(LayerListItem, { isClipped: isMask && idx < layerChildren.length - 1, item: itemsMap[id], key: id, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onSelect: onSelect })); })))));
}
export default React.memo(LayerListItem);
